import { createAction, props } from '@ngrx/store'

export const loadSettings = createAction('[Settings] Load', props<{ settings: any }>())
